export function isLastEventATransfer(events: any[]): boolean {
  const lastEvent = events[events.length - 1];

  return lastEvent ? lastEvent.type === 'transferred' : false;
}
